import logob from '../Assets/White -SOC.png'
import logoa from '../Assets/Color - SOC azul.png'
import logobrancoeng from '../Assets/SOC_certo_eng_branco.png'
import logoazuleng from '../Assets/SOC_certo_eng.png'
import chek from '../Assets/icon-check-400-rounded.svg'
import iconsL from '../Assets/language_FILL0_wght400_branco.svg'
import iconsazul from '../Assets/language_FILL0_wght400_azulescuro.svg'
import righticonsbranco from '../Assets/chevron_right_icons.svg'
import righticonsrazul from '../Assets/icons_FILL0_azul.svg'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom'; // Hook para pegar a URL atual
const Nav = () => {

    const { t, i18n } = useTranslation();

    // Função para trocar o idioma
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        window.location.href = lang === 'en' ? '/eng' : '/';
    };

    const location = useLocation(); // Obtém a URL atual

    // Define o idioma com base na URL
    useEffect(() => {
        if (location.pathname.startsWith('/eng')) {
            i18n.changeLanguage('en');
        } else {
            i18n.changeLanguage('pt');
        }
    }, [location.pathname, i18n]);

    const currentLanguage = i18n.language;

    const normalizedLanguage = i18n.language.slice(0, 2).toUpperCase();

    let logoBranco, logoAzul, linkHref;

    if (currentLanguage.toUpperCase() === 'EN') {
        logoAzul = logoazuleng; 
        logoBranco = logobrancoeng;
        linkHref = "/eng"; 
       
    } else if (currentLanguage.toUpperCase() === 'PT') {
        logoAzul = logoa; 
        logoBranco = logob;
        linkHref = "/";
    } else {
        logoAzul = logoa; 
        logoBranco = logob;
        linkHref = "/";
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
        <div className="container">
            <a className="navbar-brand logo-w" href={linkHref}>
               <img src={logoBranco} alt="Imagem" className="img-fluid logo-branco"/>
               <img src={ logoAzul} alt="Imagem" className="img-fluid logo-azul"/>
            </a>
            <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <div class="u-hamburger">
                <span class="u-hamburger__inner"></span>
                <span class="u-hamburger__inner"></span>
                <span class="u-hamburger__inner"></span>
            </div>
            
            </button>
            <div className="collapse navbar-collapse navbarResponsive" id="navbarResponsive">
                <ul className="navbar-nav ms-auto my-2 my-lg-0">
                    <a   href="#about-vw" className="nav-item font-size-1 fw-normal text-white"><span className="nav-link font-size-1 fw-semibold">{t('SOBRE')}</span></a>
                    <a  href="#contact-vw" className="nav-item font-size-1 fw-normal text-white"><span className="nav-link font-size-1 fw-semibold menu-contacto">{t('CONTACTOS')}</span></a> 
                    
                    <a  href="#contact-vw" className="nav-item font-size-1 fw-normal text-white dropdown"  id="languageDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"><span className="nav-link font-size-1 fw-semibold menu-contacto">
                        <img src={iconsL} alt="Imagem" className="img-lenb incos-language-" />
                        <img src={iconsazul} alt="Imagem" className="img-len incos-language-azul" />
                        {normalizedLanguage}
                        <img src={righticonsbranco} alt="Imagem" className="mr-2 incos-language-branco" /> 
                        <img src={righticonsrazul} alt="Imagem" className="mr-2 incos-language-azul" /></span>
                        <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                            <li>
                            
                            <button
                                className="dropdown-item txt_blue font-size-texto"
                                onClick={() => handleLanguageChange('pt')}
                            >   
                                
                                <span className={normalizedLanguage === 'PT' ? "mr-3" : "mr-15"}>
                                 {normalizedLanguage === 'PT' && (
                                    <span>
                                        <img src={chek} alt="Imagem"  />
                                    </span>
                                )}  
                                </span>
                                PORTUGUÊS

                            </button>
                            </li>
                            <li>
                            <button
                                className="dropdown-item txt_blue font-size-texto"
                                onClick={() => handleLanguageChange('en')}
                            >   
                               <span className={normalizedLanguage === 'EN' ? "mr-3" : "mr-15"}>                            
                                {normalizedLanguage === 'EN' && (
                                    <span>
                                        <img src={chek} alt="Imagem"  />
                                    </span>
                                )}
                                </span>
                               
                                ENGLISH
                                
                            </button>
                            </li>
                        </ul>
                    </a> 


                   {/* <a className="dropdown nav-item font-size-1 fw-normal text-white">
                        <span  href=""
                            className="nav-link  font-size-1 fw-normal text-white"
                            id="languageDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                           
                                <span className="font-size-1 fw-semibold">
                                <img src={iconsazul} alt="Imagem" className="mr-2 img-len incos-language-azul" /> 
                                <img src={iconsL} alt="Imagem" className="mr-2 img-lenb incos-language-branco" />
                               
                                {normalizedLanguage}
                                <img src={righticonsbranco} alt="Imagem" className="mr-2 incos-language-branco" /> 
                                <img src={righticonsrazul} alt="Imagem" className="mr-2 incos-language-azul" /> 
                                </span>  
                            
                        </span>
                        <ul className="dropdown-menu" aria-labelledby="languageDropdown">
                            <li>
                            
                            <button
                                className="dropdown-item txt_blue font-size-texto"
                                onClick={() => handleLanguageChange('pt')}
                            >   
                                <span className={normalizedLanguage === 'PT' ? "mr-3" : "mr-15"}>
                                 {normalizedLanguage === 'PT' && (
                                    <span>
                                        <img src={chek} alt="Imagem"  />
                                    </span>
                                )}  
                                </span>
                                PORTUGUÊS

                            </button>
                            </li>
                            <li>
                            <button
                                className="dropdown-item txt_blue font-size-texto"
                                onClick={() => handleLanguageChange('en')}
                            >   
                               <span className={normalizedLanguage === 'EN' ? "mr-3" : "mr-15"}>                            
                                {normalizedLanguage === 'EN' && (
                                    <span>
                                        <img src={chek} alt="Imagem"  />
                                    </span>
                                )}
                                </span>
                               
                                ENGLISH
                                
                            </button>
                            </li>
                        </ul>
                    </a>*/}


                </ul>
            </div>
        </div>
       </nav>
    )
}

export default Nav